// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1EJ2f","messages":"Chat_messages__3MMVX","dateDivider":"Chat_dateDivider__1umkB"};